/*
 *
 * TermsCheckBox
 *
 * @version 1.0.0
 * @author Alessandro Mosca
 * @since 31-Jan-2025
 */

import TermsCheckBox from './TermCheckBoxContainer'

export default TermsCheckBox
